import * as React from "react";
import styled from "styled-components";

import { Footer } from "../Footer";
import { Navigation } from "../Navigation/Navigation";
import navStructure from "../AuthNav/navStructure.residential.json";
import toolbarItems from "../AuthNav/toolbarItems.residential.json";
import { MyAccountHeaderBarContainer } from "../AuthNav";
import CrisisBanner from "../Banner/CrisisBanner";
import { Header } from "../Header";
import { SharedAppProvider } from "@origin-digital/shared-app-context";

export const BrowserContentProvider = ({ children }) => {
  // TODO: Error checking
  return children(window.oetal.pageData);
};

const ContentWrapper = styled.div`
  flex: 1 0 auto;
  ${({ background }: { background: "gray" | "white" | undefined }) => {
    if (background === "gray") return `background-color: rgb(241, 241, 241);`;
    if (background === "white") return `background-color: white;`;
    return "";
  }};
`;

const FooterWrapper = styled.div`
  flex-shrink: 0;
`;

const App = ({
  nav,
  footer,
  actionBar,
  title,
  background,
  showHeader = true,
  showFooter = true,
  authenticated = false
}) => (
  <>
    <ContentWrapper data-id="tal-content-wrapper" background={background}>
      <CrisisBanner />
      {showHeader ? (
        authenticated ? (
          <MyAccountHeaderBarContainer
            logoutUrl="/content/origin-ui/en/for-home/my-account/logout.html"
            navStructure={navStructure}
            toolbarItems={toolbarItems}
            sandbox={false}
          />
        ) : (
          <Navigation
            menuItems={nav}
            activeDropdownMenuIndex={-1}
            activeTopMenuIndex={0}
          />
        )
      ) : null}
      <SharedAppProvider xhrInitialize={authenticated}>
        <Header
          title={actionBar.title || title}
          showActionBar={!actionBar.hidden}
          mobilePropertySelector={actionBar.mobilePropertySelector}
          mobileNavButton={actionBar.mobileNavButton}
          authenticated={authenticated}
        />
      </SharedAppProvider>
      <div id="oetal-application-root" />
    </ContentWrapper>
    {showFooter ? (
      <FooterWrapper>
        <Footer {...footer} />
      </FooterWrapper>
    ) : null}
  </>
);

const Component = __DEV__ ? require("react-hot-loader").hot(module)(App) : App;

export { Component as App };
